/**
 * Extracts the numeric pixel value from a spacing token string.
 * Handles both raw values ("8px", "8") and CSS variable references
 * ("var(--eclipse-tier1-spacing-8px)").
 *
 * @remarks Nur für px-basierte Spacing/Radius-Tokens verwenden. Für rem-Werte ist diese Funktion nicht geeignet.
 */
export const convertPxTokenStringToNumber = (token: string): number => {
  const varMatch = token.match(/(\d+)px\)/);
  if (varMatch) return Number(varMatch[1]);
  const parsed = parseFloat(token);
  if (Number.isNaN(parsed)) {
    console.warn('[convertPxTokenStringToNumber] Unexpected NaN for input:', token);
    return 0;
  }
  return parsed;
};
